import { productListExpanded } from "components/Stacker/actions/StackerActions"
import PropTypes from "prop-types"
import React, { useCallback } from "react"
import ProductItem from "../../ProductList/ProductItem/ProductItem"
import "./AmuletProductList.scss"
import { shallowEqual, useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function AmuletProductList({ maxItems, collapsed = true }) {
  const { LL } = useI18nContext()
  const dispatch = useDispatch()
  const products = useSelector((state) => state.stacker.products, shallowEqual)
  const selectedList = useSelector(
    (state) => state.stacker.addedStack,
    shallowEqual
  )
  const onPreviewButtonClick = useCallback(() => {
    dispatch(productListExpanded(false))
  }, [dispatch])

  const getList = () => {
    const list = products.map((product, index) => {
      const { code } = product
      const img = `${product.productImage}_STACKER_PREVIEW.png`
      const selected =
        selectedList.includes(code) ||
        selectedList.includes(code.replace(/ /, "-"))

      return (
        <ProductItem
          key={product.code}
          maxItems={maxItems}
          product={product}
          selected={selected}
          src={img}
          style={{ margin: "5px" }}
        />
      )
    })
    return list
  }

  const list = getList()
  return (
    <React.Fragment>
      <div className="product_list-body-list grid">{list}</div>
      {!collapsed && <div className="product_list-body-overlay" />}

      <button
        className="btn btn-blackrect btn-preview-necklace mx-auto w-100"
        onClick={onPreviewButtonClick}
      >
        {LL.amulets.previewNecklace()}
      </button>
    </React.Fragment>
  )
}

AmuletProductList.propTypes = {
  collapsed: PropTypes.bool,
  maxItems: PropTypes.number.isRequired,
}

export default AmuletProductList
